"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Features = void 0;
var React = _interopRequireWildcard(require("react"));
var style = _interopRequireWildcard(require("./Features.css"));
var _uiKit = require("@cian/ui-kit");
var _icons = require("@cian/ui-kit-design-tokens/icons");
var _FullCreditTooltip = require("../../../PromoModal/parts/FullCreditPrice/FullCreditTooltip");
var _trackCreditFullPriceClick = require("../../../PromoModal/tracking/trackCreditFullPriceClick");
var _context = require("../../context");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Features = props => {
  const {
    features,
    fullCreditPriceTooltip,
    isBankMortgage
  } = props;
  const {
    setIsHoverDisabled
  } = React.useContext(_context.HoverContext);
  const handleTrackClick = React.useCallback(() => {
    (0, _trackCreditFullPriceClick.trackCreditFullPriceClick)(isBankMortgage);
    setIsHoverDisabled(true);
  }, [isBankMortgage, setIsHoverDisabled]);
  const onTooltipClose = React.useCallback(() => {
    setIsHoverDisabled(false);
  }, [setIsHoverDisabled]);
  if (features.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: style['features']
  }, features.map((feature, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: style['feature']
  }, /*#__PURE__*/React.createElement("div", {
    className: style['name']
  }, /*#__PURE__*/React.createElement(_uiKit.UIText3, {
    color: "text-secondary-default"
  }, feature.title)), !feature.valueChange && /*#__PURE__*/React.createElement("div", {
    className: style['value']
  }, /*#__PURE__*/React.createElement(_uiKit.UIText3, null, feature.value), feature.type === 'fullCreditPrice' && fullCreditPriceTooltip && /*#__PURE__*/React.createElement(_FullCreditTooltip.FullCreditPriceTooltip, {
    tooltip: fullCreditPriceTooltip,
    placement: "top",
    trackClickHandler: handleTrackClick,
    onTooltipClose: onTooltipClose
  })), feature.valueChange && /*#__PURE__*/React.createElement("div", {
    className: style['changed-value']
  }, /*#__PURE__*/React.createElement(_uiKit.UIText3, null, feature.value), /*#__PURE__*/React.createElement("div", {
    className: style['changed-value-icon']
  }, /*#__PURE__*/React.createElement(_icons.IconActionArrowRight16, {
    color: "icon-main-default"
  })), /*#__PURE__*/React.createElement(_uiKit.UIText3, null, feature.valueChange.newValue)))));
};
exports.Features = Features;